import * as React from 'react';
import { GridHeaderFilterCellProps } from '@mui/x-data-grid-pro/components/headerFiltering/GridHeaderFilterCell';
import { DateRangePickerInput } from '../../Form/DateTimePickers/DateRangePicker';
import { FilterContext } from '../DataGrid';
import './DateRange.scss';

interface DateRangePickerFilterCellProps extends GridHeaderFilterCellProps {
  dateOnly?: boolean;
}

export const DateRangePickerFilterFilter = ({ item, dateOnly }: DateRangePickerFilterCellProps) => {
  const { values, onChange, disabledFields } = React.useContext(FilterContext);
  const isDisabled = disabledFields?.has(item.field) ?? false;
  const valueString = values[item.field] ?? '';

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value;
    onChange(item.field, next || undefined);
  };

  return (
    <div style={{ width: '100%', ...(isDisabled ? { pointerEvents: 'none', opacity: 0.4 } : {}) }} onKeyDown={(e) => e.stopPropagation()}>
      <DateRangePickerInput
        onChange={handleOnChange}
        valueString={valueString}
        dateOnly={dateOnly}
        isTable
        clearable
      />
    </div>
  );
};

export default DateRangePickerFilterFilter;
